export enum TasksRoutes {
  Tasks = 'telegram/tasks/me',
}
